import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fmttaskminuta',
  templateUrl: './fmttaskminuta.component.html',
  styleUrls: ['./fmttaskminuta.component.scss']
})
export class FmttaskminutaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
